export default __webpack_public_path__ + "static/media/serv2.3aa311d4.jpg";